import { Loader, Text } from "@mantine/core";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import {
  useGetSponsor,
  useGetSponsorLevels,
  useGetSponsorReps,
} from "../../../api/sponsors";
import { getCurrentWorkspace } from "../../../services/userConfig";
import { AuthContext } from "../../../services/context";
import SponsorForm from "../SponsorForm";
import { useGetEvent } from "../../../api/event";

function EditSponsors() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();

  const { eventId } = getCurrentWorkspace(user);

  const { data: event } = useGetEvent(eventId);

  const {
    data: responseData,
    isPending: isLoading,
    isError,
    error,
  } = useGetSponsor(id);

  const {
    data: levelsData,
    isPending: levelPending,
    isError: levelsIsError,
    error: levelsError,
  } = useGetSponsorLevels({
    eventId,
  });

  const {
    data: sponsorRepsData,
    isPending: repPending,
    isError: repsIsError,
    error: repsError,
  } = useGetSponsorReps({
    eventId,
  });

  const isPending = isLoading || levelPending || repPending;
  const hasError = isError || levelsIsError || repsIsError;
  const errorMessage = error || levelsError || repsError;

  if (isPending) {
    return <Loader mt={10} />;
  }

  if (hasError) {
    return <Text c="red">{errorMessage.message}</Text>;
  }

  if (responseData && levelsData && sponsorRepsData) {
    const myReps = sponsorRepsData.filter(
      (rep) => rep.sponsorId === Number(id)
    );

    // Prepare initial data with sponsor reps
    const initialData = {
      ...responseData,
      sponsorReps: myReps,
    };

    return (
      <SponsorForm
        mode="edit"
        initialData={initialData}
        sponsorLevels={levelsData}
        event={event}
      />
    );
  }
}

export default EditSponsors;
